import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="footer-brand">
              <img src="/logo.png" alt="ScanEat" className="footer-logo" />
            </div>
            <p className="footer-desc">
              {t('hero.subtitle')}
            </p>
          </div>
          <div className="footer-col">
            <h4>{t('footer.solutions')}</h4>
            <ul>
              <li><a href="#solutions">{t('solutions.caisse.name')}</a></li>
              <li><a href="#solutions">{t('solutions.borne.name')}</a></li>
              <li><a href="#solutions">{t('solutions.qrcode.name')}</a></li>
              <li><a href="#solutions">{t('solutions.serveur.name')}</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t('footer.company')}</h4>
            <ul>
              <li><a href="#about">{t('nav.about')}</a></li>
              <li><a href="#contact">{t('nav.contact')}</a></li>
              <li><a href="#!">{t('footer.legal')}</a></li>
              <li><a href="#!">{t('footer.privacy')}</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          &copy; {new Date().getFullYear()} ScanEat. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
}
